import React, { useContext } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { useTranslation } from "react-i18next";
import { IconButton } from "@fluentui/react";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";

const MobileOverlayBottomSheet = ({ viewportData }) => {
  const { t } = useTranslation();
  const { getConsistentDateFormat } = useContext(studyReportContext);
  const { setIsUserInfoClicked } = useContext(ViewportContext);

  return (
    <div className="popup-viewer-content mobile-bottom-sheet">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "15%",
          borderBottom: "1px solid #3D3D3D",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <span className="study-list-mobile-filter-txt">Patient Data</span>
        <div className="study-list-mobile-close-icon-div">
          <IconButton
            //style={{ color: "white" }}
            //style={{color : "var(--navbar-header-popup-color-txt)"}}
            style={{color : "var(--mobile-color-txt)"}}
            iconProps={{ iconName: "Cancel" }}
            ariaLabel="Close popup filter mobile"
            onClick={() => setIsUserInfoClicked(false)}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-evenly",
          flexDirection: "column",
          height: "100%",
          borderBottom: "1px solid #3D3D3D",
          padding: "10px",
        }}
      >
        <div style={{ lineHeight: "12px" }}>
          <span className="viewport-overlay-mobile-key">
            {t("viewer.overlay.study-id")}:{" "}
          </span>
          <span className="viewport-overlay-mobile-value">
            {viewportData?.studyIdDisplay === "" ||
            viewportData?.studyIdDisplay === null ||
            viewportData?.studyIdDisplay === undefined
              ? "-"
              : viewportData?.studyIdDisplay}
            , {viewportData?.studyDescription}
          </span>
        </div>
        <div style={{ lineHeight: "12px", marginTop: "5px" }}>
          <span className="viewport-overlay-mobile-key">
            {t("viewer.overlay.study-date")}:{" "}
          </span>
          <span className="viewport-overlay-mobile-value">
            {getConsistentDateFormat(viewportData?.studyDate)}
          </span>
        </div>
        <div style={{ lineHeight: "12px", marginTop: "5px" }}>
          <span className="viewport-overlay-mobile-key">
            {t("viewer.overlay.patient-id")}:{" "}
          </span>
          <span className="viewport-overlay-mobile-value">
            {viewportData?.patientId}
          </span>
        </div>
        <div style={{ lineHeight: "12px", marginTop: "5px" }}>
          <span className="viewport-overlay-mobile-key">
            {t("viewer.overlay.patient-name")}:{" "}
          </span>
          <span className="viewport-overlay-mobile-value">
            {viewportData?.patientName}
          </span>
        </div>
        <div style={{ lineHeight: "12px", marginTop: "5px" }}>
          <span className="viewport-overlay-mobile-key">
            {t("viewer.overlay.gender")}:{" "}
          </span>
          <span className="viewport-overlay-mobile-value">
            {viewportData?.patientSex === "M"
              ? t("viewer.overlay.male")
              : t("viewer.overlay.female")}
          </span>
        </div>
        <div style={{ lineHeight: "12px", marginTop: "5px" }}>
          <span className="viewport-overlay-mobile-key">
            {t("viewer.overlay.age")}:{" "}
          </span>
          <span className="viewport-overlay-mobile-value">
            {viewportData?.patientAge?.slice(0, 1) === "0"
              ? viewportData?.patientAge?.slice(1, 3) === "-"
                ? ""
                : viewportData?.patientAge?.slice(1, 3)
              : viewportData?.patientAge?.slice(0, 3) === "-"
              ? ""
              : viewportData?.patientAge?.slice(0, 3)}
          </span>
        </div>
        <div style={{ lineHeight: "12px", marginTop: "5px" }}>
          <span className="viewport-overlay-key">
            {t("viewer.overlay.series")}:{" "}
          </span>
          <span className="viewport-overlay-value">{viewportData?.series}</span>
        </div>
        <div style={{ lineHeight: "12px", marginTop: "5px" }}>
          <span className="viewport-overlay-key">
            {t("viewer.overlay.modality")}:{" "}
          </span>
          <span className="viewport-overlay-value">
            {viewportData?.modality}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MobileOverlayBottomSheet;
